import React, { useState, useEffect } from 'react';
import './HideRemoveDropdownModal.css';

const HideRemoveDropdownModal = ({ 
  isOpen, 
  onClose, 
  onStatusSelect,
  onEdit,
  onDelete,
  currentStatus = null,
  position = null 
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleStatusClick = async (status) => {
    if (onStatusSelect) {
      try {
        await onStatusSelect(status);
      } catch (error) {
        console.error('Status update error:', error);
        // Close modal even on error
        onClose();
      }
    } else {
      onClose();
    }
    // onClose is called from parent after successful status update
  };

  const handleEditClick = () => {
    onClose();
    if (onEdit) {
      onEdit();
    }
  };

  const handleDeleteClick = async () => {
    if (onDelete) {
      try {
        await onDelete();
      } catch (error) {
        console.error('Delete error:', error);
      }
    }
    // onClose is handled by parent after delete
  };

  // Calculate position styles if position prop is provided (desktop only)
  const containerStyle = !isMobile && position ? {
    left: position.x,
    top: position.y,
  } : !isMobile ? {
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  } : {};

  return (
    <div className="hide-remove-dropdown-modal-overlay" onClick={handleOverlayClick}>
      <div className="hide-remove-dropdown-modal-container" style={containerStyle}>
        {/* Edit Option */}
        <button
          className="hide-remove-option edit"
          onClick={handleEditClick}
          type="button"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="#1F396C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M18.5 2.50001C18.8978 2.10219 19.4374 1.87869 20 1.87869C20.5626 1.87869 21.1022 2.10219 21.5 2.50001C21.8978 2.89784 22.1213 3.4374 22.1213 4.00001C22.1213 4.56262 21.8978 5.10219 21.5 5.50001L12 15L8 16L9 12L18.5 2.50001Z" stroke="#1F396C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span className="hide-remove-option-text">Edit</span>
        </button>

        {/* Active Status Option */}
        <button
          className={`hide-remove-option active-status ${currentStatus === 'active' ? 'selected' : ''}`}
          onClick={() => handleStatusClick('active')}
          type="button"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 6L9 17L4 12" stroke="#059669" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span className="hide-remove-option-text">Set Active</span>
        </button>

        {/* Hide Status Option */}
        <button
          className={`hide-remove-option hide ${currentStatus === 'hidden' ? 'selected' : ''}`}
          onClick={() => handleStatusClick('hidden')}
          type="button"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20C7 20 2.73 16.11 1 12C1.69 10.24 2.79 8.69 4.19 7.48M9.88 9.88A3 3 0 0 0 12 15A3 3 0 0 0 14.12 9.88" stroke="#6D6D6D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M1 1L23 23" stroke="#6D6D6D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span className="hide-remove-option-text">Hide</span>
        </button>

        {/* Delete Option */}
        <button
          className="hide-remove-option removed"
          onClick={handleDeleteClick}
          type="button"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 6H5H21" stroke="#DC2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="#DC2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span className="hide-remove-option-text">Delete</span>
        </button>
      </div>
    </div>
  );
};

export default HideRemoveDropdownModal;
